import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdminRoutingModule } from './admin-routing.module';
import { LayoutPageComponent } from './components/layout-page/layout-page.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../material.module';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { IonicModule } from '@ionic/angular';
import { ReviewReasonComponent } from './components/review-reason/review-reason.component';
import { ViewReasonComponent } from './components/view-reason/view-reason.component';
import { BsDatepickerModule, DatepickerModule } from 'ngx-bootstrap';
import { StartupListComponent } from './menus/startup-list/startup-list.component';
import { Tnimm2PageComponent } from './tnimm2-page/tnimm2-page.component';
// import { PasswordComponent } from './menus/password/password.component';

@NgModule({
  declarations: [LayoutPageComponent, ReviewReasonComponent, ViewReasonComponent, StartupListComponent, Tnimm2PageComponent],
  imports: [
    CommonModule,
    AdminRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    NgxMaterialTimepickerModule,   
    IonicModule.forRoot(),
    DatepickerModule,
    BsDatepickerModule.forRoot(),
  ],
  entryComponents:[ReviewReasonComponent,ViewReasonComponent]
})
export class AdminModule { }
